import React, {useState} from 'react'
import Modal from '../../../components/Modal/Modal';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import {TextareaAutosize} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import './AggregateModal.scss';
import BackofficeService, {prepareEventsAsJson} from '../services/BackofficeService';
import {notificationService} from '../../../components/Notifications/Notifications';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const initialState = {
  vendorKey: '',
  serialNumber: '',
  displayPayloadAggregate: '',
  displayPayloadEvents: '',
  asEvents: false,
  countEvents: 0
}

const CreditAdviceAggregateModal = ({modalToggled, toggleModal}) => {

  const [state, setState] = useState(initialState);

  const handleVendorKeyChanged = (event) => {
    let {value} = event.target;
    setState({...state, vendorKey: value});
  }

  const handleSerialNumberChanged = (event) => {
    let {value} = event.target;
    setState({...state, serialNumber: value});
  }

  const handleToggleAsEvents = (event, checked) => {
    setState({...state, asEvents: checked});
  }

  const handleSubmit = () => {
    if (state.asEvents) {
      BackofficeService.getCreditAdviceAggregateEvents(state.vendorKey, state.serialNumber)
        .then((payload) => {
          let {resStr, countEvents} = prepareEventsAsJson(payload);
          setState({...state, displayPayloadEvents: resStr, countEvents: countEvents})
        })
        .catch(() => notificationService.error(`Konnte Aggregate '${state.serialNumber}' nicht finden`));
    } else {
      BackofficeService.getCreditAdviceAggregate(state.vendorKey, state.serialNumber)
        .then((payload) => {
          const str = JSON.stringify(payload, null, 4)
          setState({...state, displayPayloadAggregate: str})
        })
        .catch(() => notificationService.error(`Konnte Aggregate '${state.serialNumber}' nicht finden`));
    }
  };

  return (
    <div>
      <Modal modalToggled={modalToggled} toggleModal={toggleModal} hasClosingButton={false}
             modalBackgroundColor={'#ffffff'} modalWidth={'60vw'}>
        <div className='aggregateModal'>
          <h2 className='aggregateModal__title'>Fetch CreditAdvice aggregate</h2>
          <div className='aggregateModal__grid'>
            <div className='aggregateModal__grid__vendorKey'>
              <TextField
                value={state.vendorKey}
                fullWidth={true}
                onChange={handleVendorKeyChanged}
                id='vendorKey'
                label='vendorKey'
                variant='outlined'
              />
            </div>
            <div className='aggregateModal__grid__serialNumber'>
              <TextField
                fullWidth={true}
                value={state.serialNumber}
                onChange={handleSerialNumberChanged}
                id='serialNumber'
                label='serialNumber'
                variant='outlined'
              />
            </div>
            <div className='aggregateModal__grid__rawEvents'>
              <FormControlLabel
                control={
                  <Checkbox
                    color='primary'
                    onChange={(evt, checked) => handleToggleAsEvents(evt, checked)}
                    value='asRawEvents'/>
                }
                label={'Raw Events'}
              />
              {state.asEvents && <div>Events fetched: <strong>{state.countEvents}</strong></div>}
            </div>
          </div>
          <FormControl fullWidth={true}>
            <TextareaAutosize
              readOnly={true}
              className='aggregateModal__textarea'
              rowsMin={20}
              rowsMax={20}
              value={state.asEvents ? state.displayPayloadEvents : state.displayPayloadAggregate}
            />
          </FormControl>
          <Box>
            <Button onClick={() => toggleModal()} type='submit'> Close </Button>
            <Button color='primary' type='submit' onClick={() => handleSubmit()}> Fetch </Button>
          </Box>
        </div>
      </Modal>
    </div>
  );
}

export default CreditAdviceAggregateModal;
